import { Card, CardContent, Collapse } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const CollapseContainer = styled.div`
  max-height: 104px;
  background: ${COLORS.primary};
  margin-top: 14px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
`

export const CollapseInfo = styled.div`
  margin-top: -3px;
  margin-bottom: -10px;
`

export const CollapseStyled = styled(Collapse)``
export const CardStyled = styled(Card)`
  margin-top: 14px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  background: ${COLORS.white};
`

interface CardContentProps {
  isHeader?: boolean
}

export const CardContentStyled = styled(CardContent)<CardContentProps>`
  background: ${({ isHeader }) =>
    isHeader ? COLORS.headerColor : COLORS.white};
`
